/*-----------------------------------------------------------------*/
/*								すべてのページで必要となりそうなjs							 */
/*-----------------------------------------------------------------*/


//-------------------------------------
//	メガネマーク
//	2016年7月変更部分
//-------------------------------------
$(function(){
	$('#search_submit').click(function(){
		$('#as2_search_form').submit();
	});

});

//-------------------------------------
//	お買物案内、お知らせ、などの開閉
//	2016年7月変更部分
//-------------------------------------
$(function(){
	//マウスがボタンに入った時
	$(".window_button_click").click(function(){
		console.log("window_button_click");
		window_click_open_close(this);
	});

	function window_click_open_close(target_win){
		console.log("window_open_close");
		$(".toggle_window").stop();	//アニメーションをストップ

		//win_objが開く対象ウィンドウ
		var win_str = $(target_win).data("window");
		var win_obj = $("#"+win_str);

		//そのウィンドウが既に開いているか
		if(win_obj.css("display") == "block"){
			$(".toggle_window").fadeOut(200);
			return;
		}

		if(win_obj.css("display") == "none"){
			$(".toggle_window").hide();
		}

		var mode = $(target_win).data("mode");					//カテゴリウィンドウか、別のウィンドウか
		var y_add = $(target_win).data("y_add");	//y軸の位置移動

		//positionがfixed、すなわちヘッダが固定されている時
		if(win_obj.css("position") == "fixed"){
			if(mode == "cat"){
				offset = $(target_win).position();
				var x = offset.top + $(target_win).height();
//				win_obj.css("top",x).css("left",0).fadeIn(200);
			} else {
				offset = $(target_win).position();
				var x = offset.top + $(target_win).height()+10;
				var y = offset.left - (win_obj.width() / 2) + y_add;
//				win_obj.css("top",x).css("left",y).fadeIn(200);
			}
//			$(this).css("z-index","2");
		}

		//positionがabsolute、すなわちヘッダが固定されてない時
		if(win_obj.css("position") == "absolute"){
			if(mode == "cat"){
				offset = $(target_win).offset();
				var x = offset.top + $(target_win).height();
				win_obj.css("top",x).css("left",0).css("z-index","3").fadeIn(200);
			} else {
				offset = $(target_win).offset();
				var x = offset.top + $(target_win).height()+10;
				var y = offset.left - (win_obj.width() / 2) +y_add;
				win_obj.css("top",x).css("left",y).css("z-index","3").fadeIn(200);
			}
			$(target_win).css("z-index","3");
		}

	}
	
});

//-------------------------------------
//	カテゴリウィンドウの開閉
//	2016年7月変更部分
//-------------------------------------
$(function(){
	//マウスが外れた時
	$("#toggle_out").hover(function(){
		console.log("#toggle_out");
		clearTimeout(sethover);
		$(".toggle_window").fadeOut(200);
		$("#toggle_out").hide();
	});

	//マウスがボタンに入った時
	$(".window_button").hover(function(){
			var win = this;

			//何かのウィンドウが既に開いているか
			var win_open_flg=0;
			$(".cat_win").each(function(){
				if($(this).css("display") == "block"){
					win_open_flg=1;
					return false;
				}
			});
			if(win_open_flg){
				//開いている場合はすぐOPEN
				window_open_close(win);
			}else{
				//まだ開いていない場合は遅延OPEN
				sethover = setTimeout(function(){
					console.log("window_button");
					window_open_close(win);
				},200);
			}
		},function(){
			clearTimeout(sethover);
		}
	);

	//開閉本体
	function window_open_close(target_win){
		console.log("window_open_close");
		$(".toggle_window").stop();	//アニメーションをストップ

		//win_objが開く対象ウィンドウ
		var win_str = $(target_win).data("window");
		var win_obj = $("#"+win_str);

		//そのウィンドウが既に開いているか
		if(win_obj.css("display") == "block"){
			$(".toggle_window").css("opacity","1");
			return;
		}

		if(win_obj.css("display") == "none"){
			$(".toggle_window").hide();
		}

		var mode = $(target_win).data("mode");					//カテゴリウィンドウか、別のウィンドウか
		var y_add = $(target_win).data("y_add");	//y軸の位置移動

		//positionがfixed、すなわちヘッダが固定されている時
		if(win_obj.css("position") == "fixed"){
			if(mode == "cat"){
				offset = $(target_win).position();
				var x = offset.top + $(target_win).height();
//				win_obj.css("top",x).css("left",0).fadeIn(200);
			} else {
				offset = $(target_win).position();
				var x = offset.top + $(target_win).height()+10;
				var y = offset.left - (win_obj.width() / 2) + y_add;
//				win_obj.css("top",x).css("left",y).fadeIn(200);
			}
//			$(this).css("z-index","2");

			//relにあるsrcを移動(重さ回避のため)
			$(win_obj).find('img').each(function(){
				var mURL = $(this).attr('data-src');
				$(this).attr('src',mURL);
			});

			$("#toggle_out").show();
//		  $('.cat_main_wrapper').masonry();

		}

		//positionがabsolute、すなわちヘッダが固定されてない時
		if(win_obj.css("position") == "absolute"){
			if(mode == "cat"){
				offset = $(target_win).offset();
				var x = offset.top + $(target_win).height();
				win_obj.css("top",x).css("left",0).css("z-index","2").fadeIn(200);
			} else {
				offset = $(target_win).offset();
				var x = offset.top + $(target_win).height()+10;
				var y = offset.left - (win_obj.width() / 2) +y_add;
				win_obj.css("top",x).css("left",y).css("z-index","2").fadeIn(200);
			}

			//relにあるsrcを移動(重さ回避のため)
			$(win_obj).find('img').each(function(){
				var mURL = $(this).attr('data-src');
				$(this).attr('src',mURL);
			});

			$(target_win).css("z-index","2");
			$("#toggle_out").show();
//		  $('.cat_main_wrapper').masonry();
		}
	}
	
});


//------------------------------------------------------
//	カートに入っている商品の数を取得
//------------------------------------------------------
if("http:" == document.location.protocol)
{
	$(function(){
		$("#cart_in_num").load("http://www.tirakita.com/cgi-bin/phpcart5/cart_in_num_get_ajax.php?csrf="+$("#csrf").val());
	});
}else{
	//CORS制限に引っかかるのでAjax関数での呼び出し
	$(function(){
		$.ajax({
		  url: "https://www.tirakita.com/cgi-bin/phpcart5/cart_in_num_get_ajax.php?csrf="+$("#csrf").val(),
		  xhrFields: {
		    withCredentials: true
		  },
			success: function(html){
				if(html){
					$("#cart_in_num").html(html);
					$("#cart_in_num").css("display","block");
				}
			}
		})
	});
}

//------------------------------------------------------
//	お客様通知項目を見たことをセットする Ajaxを呼び出し
//------------------------------------------------------
$(function(){
	$("#kyaku_tsuuchi_win_icon").click(function(){
	$.ajax({
	  url: "https://www.tirakita.com/sys/HP_Make/kyaku_tsuuchi_set_ajax.php?csrf="+$("#csrf").val(),
	  xhrFields: {
	    withCredentials: true
	  }
	})

//		$('body').append("<div id='dummy'></div>");
//		$("#dummy").load("http://www.tirakita.com/sys/HP_Make/kyaku_tsuuchi_set_ajax.php?csrf="+$("#csrf").val());
//		$("#dummy").remove();
		$("#tsuuchi_num").remove();
	});

});

//------------------------------------------------------
// プラグインの存在をチェックします
//------------------------------------------------------
pluginExists = function( pluginName ){
  return $.fn[pluginName] ? true : false;
}

//------------------------------------------------------
//		指定classの縦サイズを揃える
//------------------------------------------------------
set_max_height = function(cs){
	var max_height = 0;
	$(cs).each(function(){	//最大の高さを求める
		if(max_height < $(this).height()) max_height = $(this).height();
	});

	$(cs).each(function(){	//それを全部にセット
		$(this).height(max_height);
	});
}

//------------------------------------------------------
//		画像の横サイズを指定サイズに
//------------------------------------------------------
set_img_wsize = function(cs,size){
	$(cs).each(function(){
		if($(this).width() > size){
			var height = $(this).height();
			var ratio = size / $(this).width();
			var height = ratio * height;
			$(this).width(size);
			$(this).height(height);
		}
	});
}

//-------------------------------------
//	携帯かどうかの判定
//-------------------------------------
chk_device = function(){
	//iPhoneまたは、Androidの場合は振り分けを判断
	if ((navigator.userAgent.indexOf('iPhone') > 0) || (navigator.userAgent.indexOf('iPad') > 0) || (navigator.userAgent.indexOf('iPod') > 0) || navigator.userAgent.indexOf('Android') > 0) {
		return "sumaho";
	}
	return "pc";
}


//-------------------------------------
//	■page topボタン
//-------------------------------------
$(function(){
	$('#pageTop').hide();
  var startPos = 0;
 
  $(window).scroll(function(){
    var currentPos = $(this).scrollTop();
    if (currentPos > startPos) {
      if($(window).scrollTop() >= 0) {
        $("#pageTop").hide();
      }
    } else {
      $("#pageTop").fadeIn();
    }
    startPos = currentPos;
  });
});

//------------------------------------------------------
//		ページ編集機能の開閉
//------------------------------------------------------
$(function(){
	$(".toggle_page").on("click",function(){
		let target_id = $(this).data("target_id");
		$("#"+target_id).toggle();
	});

});

/*-------------------------------------------------
			iPhone用カテゴリ、お客様ページの開閉
-------------------------------------------------*/
$(function(){
	/* タッチできる環境なら true、そうでないなら false 。
			ここで先に判別しておきます。 */
	var isTouch = ('ontouchstart' in window);

	$("#category_button").on("click",function(){
		$("#category_div img").each(function(){
			$(this).attr("src",$(this).data("original"));
		});
		if(isTouch) event.preventDefault();
		$("#back_dark").show(); 
		$("#category_div").show(); 
	});

	$("#login_button").on("click",function(){
		$("#category_div img").each(function(){
			$(this).attr("src",$(this).data("original"));
		});

		if(isTouch) event.preventDefault();
		$("#back_dark").show(); 
		$("#login_div").show(); 
	});

	$("#back_dark").on("click",function(){
		$("#back_dark").fadeOut(200);
		$("#category_div").fadeOut(200);
		$("#login_div").fadeOut(200);
	});
});


//------------------------------------------------------
//		スクロールパフォーマンスを高める受動的なリスナーが使用されていません問題の解決
//------------------------------------------------------

jQuery.event.special.touchstart={setup:function(e,t,s){t.includes("noPreventDefault")?this.addEventListener("touchstart",s,{passive:!1}):this.addEventListener("touchstart",s,{passive:!0})}},jQuery.event.special.touchmove={setup:function(e,t,s){t.includes("noPreventDefault")?this.addEventListener("touchmove",s,{passive:!1}):this.addEventListener("touchmove",s,{passive:!0})}},jQuery.event.special.wheel={setup:function(e,t,s){this.addEventListener("wheel",s,{passive:!0})}},jQuery.event.special.mousewheel={setup:function(e,t,s){this.addEventListener("mousewheel",s,{passive:!0})}};